import useTranslation from '@Queries/useTranslation';
import Link from '@UI/Link';
import Img from '@UI/Img';
import ImgArrow from './image/arrow.svg';
import styles from './Button.module.css';

import type { FC } from 'react';
import type { LinkProps } from '@divlab/divanui';

interface ButtonProps extends Omit<LinkProps, 'view'> {
  view?: 'choose' | 'change' | 'arrow';
}

const Button: FC<ButtonProps> = (props) => {
  const { view = 'change', ...restProps } = props;
  const { t } = useTranslation();

  return (
    <Link {...restProps} underlined view='primary'>
      {view === 'change' && <p className={styles.text}>{t('kits.button.change')}</p>}
      {view === 'choose' && <p className={styles.text}>{t('kits.button.choose')}</p>}
      {view === 'arrow' && <Img className={styles.img} src={ImgArrow} />}
    </Link>
  );
};

export default Button;
